import {tap} from 'rxjs/operators';
import {HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ToastrService} from 'ngx-toastr';

import {LoginService} from 'app/core/login/login.service';
import {PASSWORD_EXPIRED_ERROR_CODE, PASSWORD_EXPIRED_MESSAGE_KEY} from 'app/app.constants';

/** How long the toast stays up before the sign-out redirect. */
const PASSWORD_EXPIRED_REDIRECT_DELAY_MS = 2500;

export class AuthExpiredInterceptor implements HttpInterceptor {
    /** A single screen fires many requests; only the first expiry response should act. */
    private passwordExpiryHandled = false;

    constructor(
        private _loginService: LoginService,
        private _toastr: ToastrService
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            tap(
                (event: HttpEvent<any>) => {},
                (err: any) => {
                    if (err instanceof HttpErrorResponse) {
                        if (err.status === 401) {
                            console.log('[AuthExpiredInterceptor] Authentication has expired. Logging out.');
                            this._loginService.logout();
                        } else if (err.status === 403 && err.error?.errorCode === PASSWORD_EXPIRED_ERROR_CODE && !this.passwordExpiryHandled) {
                            // The session is valid but the password is past the company's rotation
                            // period. Say why, then sign the user out and send them to the login
                            // screen - the API has already emailed them a reset link.
                            this.passwordExpiryHandled = true;
                            const message = err.error.detail;

                            this._toastr.error(message, 'Password expired');
                            // The redirect reloads the app and discards the toast, so hand the
                            // message to the login screen as well.
                            sessionStorage.setItem(PASSWORD_EXPIRED_MESSAGE_KEY, message);
                            setTimeout(() => this._loginService.logout(true), PASSWORD_EXPIRED_REDIRECT_DELAY_MS);
                        }
                    }
                }
            )
        );
    }
}
